import { useEffect, useState, useRef } from 'react';
import { ContactPage, ManageAccounts, Cancel } from '@mui/icons-material';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';

// material-ui
import {
    Box,
    Button,
    Grid,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    TextField,
    FormControl,
    Select,
    MenuItem,
    Autocomplete,
    CircularProgress
} from '@mui/material';

import { useTheme } from '@mui/material/styles';
import { deepPurple } from '@mui/material/colors';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { gridSpacing } from 'app/constant';

import { useSelector } from 'react-redux';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { axiosInstance } from 'utils/axios';
import { toast } from 'react-toastify';
import { bgcolor } from '@mui/system';
import * as XLSX from 'xlsx';

import useFetchData from 'hooks/useFetchData';
import BatchUpdateWithdrawalByIDRangeModal from './components/BatchUpdateWithdrawalByIDRangeModal';
import BatchUpdateWithdrawalModal from './components/BatchUpdateWithdrawalModal';
import ApproveWithdrawalModal from './components/ApproveWithdrawalModal';
import RejectWithdrawalModal from './components/RejectWithdrawalModal';
import UpdateUnderReviewWithdrawalModal from './components/UpdateUnderReviewWithdrawalModal';

import { useTranslation } from "react-i18next";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 800,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const columns = [
    { id: 'id', label: '时间', minWidth: 170 },
    { id: 'customerDetails', label: '用户', minWidth: 170 },
    { id: 'createdBy', label: '代理', minWidth: 170 },
    { id: 'bankDetails', label: '银行卡信息	', minWidth: 170 },
    { id: 'amount', label: '实际到账', minWidth: 170 },
    { id: 'updatedBy', label: '操作员', minWidth: 170 },
    { id: 'action', label: '操作', minWidth: 170 }
];

const ViewDetailsModal = ({ id }) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const token = useSelector(selectCurrentToken);
    const [saleDetails, setSaleDetails] = useState({});

    const fetchSalesDetails = async () => {
        try {
            const res = await axiosInstance.get(`/Withdrawal/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setSaleDetails(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (open) {
            fetchSalesDetails();
        }
    }, [open]);

    return (
        <div>
            <Button
                onClick={handleOpen}
                sx={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    width: 'fit-content',
                    height: 'fit-content',
                    color: deepPurple[500]
                }}
            >
                <ContactPage />
            </Button>
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography id="modal-modal-title" variant="h3" component="h2">
                            Withdrawal Records Details
                        </Typography>
                        <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                    </Box>

                    <Box
                        id="modal-modal-description"
                        sx={{
                            height: '400px',
                            overflowY: 'auto'
                        }}
                    >
                        <Grid item container xs={12} sx={{ mt: 2 }}>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Client Name : <span style={{ fontWeight: 600 }}>{saleDetails.clientName}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Amount : <span style={{ fontWeight: 600 }}>{saleDetails.amount}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Status : <span style={{ fontWeight: 600 }}>{saleDetails.statusName}</span>
                                </Typography>
                            </Grid>
                            {/* <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Package Name : <span style={{ fontWeight: 600 }}>{saleDetails.packageName}</span>
                                </Typography>
                            </Grid> */}
                            {/* <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Third Party Name : <span style={{ fontWeight: 600 }}>{saleDetails.thirdPartyName}</span>
                                </Typography>
                            </Grid> */}
                            {/* <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Third Party Charges : <span style={{ fontWeight: 600 }}>{saleDetails.thirdPartyCharges}</span>
                                </Typography>
                            </Grid> */}
                            {/* <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Third Party Charges Type :{' '}
                                    <span style={{ fontWeight: 600 }}>{saleDetails.thirdPartyChargesTypeName}</span>
                                </Typography>
                            </Grid> */}
                            {/* <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Estimated Profit : <span style={{ fontWeight: 600 }}>{saleDetails.estimatedProfit}</span>
                                </Typography>
                            </Grid> */}
                            {/* <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Estimated Daily Profit Profit :{' '}
                                    <span style={{ fontWeight: 600 }}>{saleDetails.estimatedDailyProfit}</span>
                                </Typography>
                            </Grid> */}
                            {/* <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Converted Amount : <span style={{ fontWeight: 600 }}>{saleDetails.convertedAmountString}</span>
                                </Typography>
                            </Grid> */}
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Created By : <span style={{ fontWeight: 600 }}>{saleDetails.createdBy}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Created Date :{' '}
                                    <span style={{ fontWeight: 600 }}>
                                        {saleDetails.createdDate &&
                                            `${saleDetails.createdDate?.split('T')[0]} 
                  ${new Date('1970-01-01T' + saleDetails.createdDate?.split('T')[1] + 'Z').toLocaleTimeString('en-US', {
                      timeZone: 'UTC',
                      hour12: true,
                      hour: 'numeric',
                      minute: 'numeric',
                      second: 'numeric'
                  })}`}
                                    </span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Updated By : <span style={{ fontWeight: 600 }}>{saleDetails.updatedBy}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Updated Date :{' '}
                                    <span style={{ fontWeight: 600 }}>
                                        {saleDetails.updatedDate &&
                                            `${saleDetails.updatedDate?.split('T')[0]} 
                  ${new Date('1970-01-01T' + saleDetails.updatedDate?.split('T')[1] + 'Z').toLocaleTimeString('en-US', {
                      timeZone: 'UTC',
                      hour12: true,
                      hour: 'numeric',
                      minute: 'numeric',
                      second: 'numeric'
                  })}`}
                                    </span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    User Name : <span style={{ fontWeight: 600 }}>{saleDetails.userName}</span>
                                </Typography>
                            </Grid>

                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Approved Date :{' '}
                                    <span style={{ fontWeight: 600 }}>
                                        {saleDetails.approvedDate &&
                                            `${saleDetails.approvedDate?.split('T')[0]} 
                  ${new Date('1970-01-01T' + saleDetails.approvedDate?.split('T')[1] + 'Z').toLocaleTimeString('en-US', {
                      timeZone: 'UTC',
                      hour12: true,
                      hour: 'numeric',
                      minute: 'numeric',
                      second: 'numeric'
                  })}`}
                                    </span>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};

const SalesRecord = () => {
    const { t } = useTranslation();
    const buttonRef = useRef(null);
    const triggeredByKeyRef = useRef(false);

    const user = useSelector(selectCurrentUser);
    const token = useSelector(selectCurrentToken);
    const theme = useTheme();
    const [expensesTypes, setExpensesTypes] = useState([]);
    const [thirdparty, setThirdParty] = useState([]);
    const [packages, setPackages] = useState([]);
    const [saleStatus, setSalesStatus] = useState([]);
    const [sales, setSales] = useState([]);
    const [filterSalesFrom, setFilerSalesFrom] = useState(dayjs().subtract(7, 'days'));
    const [filterSalesTo, setFilerSalesTo] = useState(dayjs());
    const [insertWithdrawalCustomerName, setInsertWithdrawalCustomerName] = useState('');
    const [filterSalesUserName, setFilterSalesUserName] = useState('');
    const [filterSalesStatus, setFilterSalesStatus] = useState('1');
    const [filterSalesPackage, setFilterSalesPackage] = useState('');
    const [filterSalesThirdParty, setFilterSalesThirdParty] = useState('');
    const [filterSalesCustomerID, setFilterSalesCustomerID] = useState('');
    const [filterSalesBankAccountNumber, setFilterSalesBankAccountNumber] = useState('');

    const [filterWithdrawalLoginUserName, setFilterWithdrawalLoginUserName] = useState('');
    const [filterWithdrawalLoginUserNameInputText, setFilterWithdrawalLoginUserNameInputText] = useState('');
    const [filterWithdrawalLoginUserNameHighlightedOption, setFilterWithdrawalLoginUserNameHighlightedOption] = useState('');

    const [customerNameOptions, setCustomerNameOptions] = useState([]);
    const [customerNameListArr, setCustomerNameListArr] = useState([]);
    const [customerNameList, setCustomerNameList] = useState([]);

    const [filterWithdrawalNumberCode, setFilterWithdrawalNumberCode] = useState('');
    const [filterWithdrawalNumberCodeInputText, setFilterWithdrawalNumberCodeInputText] = useState('');
    const [filterWithdrawalNumberCodeHighlightedOption, setFilterWithdrawalNumberCodeHighlightedOption] = useState('');

    const [usersList, setUsersList] = useState([]);
    const [UserNameOptions, setUserNameOptions] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [isAllowFilterUserName, setIsAllowFilterUserName] = useState();
    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);

    const { data: customerLoginUserNameOptions } = useFetchData('/Customer/LoginUserNames');
    const { data: customerNamesOptions } = useFetchData('/Customer/Names');
    const { data: withdrawalRejectReasonOptions } = useFetchData('/WithdrawalRejectReasons/All');
    const { data: customerNumberCodeOptions } = useFetchData('/Customer/NumberCodes');

    const warningAlert = (message) => {
        toast.warning(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const successAlert = (message) => {
        toast.success(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const errorAlert = (message) => {
        toast.error(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    useEffect(() => {
        const usernames = usersList.map((customer) => customer.userName);
        const namesArray = customerNameListArr.map((item) => item.name);
        setCustomerNameList(namesArray);
        setUserNameOptions(usernames);
    }, [usersList, customerNameListArr]);

    //fetch customer names for autocomplete start
    const fetchCustomerNamesOptions = async () => {
        try {
            const res = await axiosInstance.get('/Customer/Names', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setCustomerNameOptions(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch customer names for autocomplete end

    //fetch customer names for autocomplete start
    const fetchCustomerNamesList = async () => {
        try {
            const res = await axiosInstance.get('/Customer/NameList', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setCustomerNameListArr(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch customer names for autocomplete end

    //fetch customer names for autocomplete start
    const fetchUserNamesOptions = async () => {
        try {
            const res = await axiosInstance.get('/Usernames', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setUsersList(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch customer names for autocomplete end

    //fetch expenses types start
    const fetchExpensesTypes = async () => {
        try {
            const res = await axiosInstance.get('/ExpensesType', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setExpensesTypes(res.data);
            } else {
                errorAlert('Something Went Wrong');
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch expenses types end

    //fetch available packages start
    const fetchPackages = async () => {
        try {
            const res = await axiosInstance.get('/AvailablePackage', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setPackages(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch availabel packages end

    //fetch third party start
    const fetchThirdParty = async () => {
        try {
            const res = await axiosInstance.get('/ThirdParty', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setThirdParty(res.data);
            } else {
                errorAlert('Something went wrong');
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch third party end

    const fetchSalesStatus = async () => {
        try {
            const res = await axiosInstance.get('/SalesStatus', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setSalesStatus(res.data);
            } else {
                errorAlert('Something went wrong');
            }
        } catch (error) {
            console.log(error);
        }
    };

    //fetch currency start
    const fetchCurrency = async () => {
        try {
            const res = await axiosInstance.get('/Currency', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setCurrencies(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch currency end

    const [isAllowedTransaction, setIsAllowedTransaction] = useState();
    //fetch customer names for autocomplete start
    const fetchIsAllowedTransaction = async () => {
        try {
            const res = await axiosInstance.get('/IsAllowed/Transaction', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setIsAllowedTransaction(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch customer names for autocomplete end

    //fetch sales start
    const [fetchWithdrawal, setFetchWithdrawal] = useState(false);
    const fetchSales = async () => {
        setFilterBtnDisabled(true);

        if (triggeredByKeyRef.current) {
            triggeredByKeyRef.current = false; // Reset the flag
            return;
        }

        if (!filterSalesFrom.isValid() || !filterSalesTo.isValid()) {
            warningAlert('Please fill all required fields.');
            return;
        }
        let salesURL = `/Withdrawal/All?createdDateFrom=${filterSalesFrom.format('YYYY-MM-DD')}&createdDateTo=${filterSalesTo.format(
            'YYYY-MM-DD'
        )}`;

        if (insertWithdrawalCustomerName !== '') {
            salesURL += `&clientName=${insertWithdrawalCustomerName}`;
        }

        // if (filterWithdrawalLoginUserNameHighlightedOption || filterWithdrawalLoginUserNameInputText !== '') {
        //     salesURL += `&loginUserName=${filterWithdrawalLoginUserNameHighlightedOption || filterWithdrawalLoginUserNameInputText}`;
        // }
        if (filterWithdrawalLoginUserName !== '') {
            salesURL += `&loginUserName=${filterWithdrawalLoginUserName}`;
        }

        if (filterSalesUserName !== '') {
            salesURL += `&searchUserID=${filterSalesUserName}`;
        }
        if (filterSalesStatus !== '') {
            salesURL += `&statusID=${filterSalesStatus}`;
        }
        if (filterSalesPackage !== '') {
            salesURL += `&packageID=${filterSalesPackage}`;
        }
        if (filterSalesThirdParty !== '') {
            salesURL += `&thirdPartyID=${filterSalesThirdParty}`;
        }

        // if (filterWithdrawalNumberCodeHighlightedOption || filterWithdrawalNumberCodeInputText !== '') {
        //     salesURL += `&numberCode=${filterWithdrawalNumberCodeHighlightedOption || filterWithdrawalNumberCodeInputText}`;
        // }
        if (filterWithdrawalNumberCode !== '') {
            salesURL += `&numberCode=${filterWithdrawalNumberCode}`;
        }
        if (filterSalesBankAccountNumber !== '') {
            salesURL += `&bankAccountNumber=${filterSalesBankAccountNumber}`;
        }

        setFetchWithdrawal(true);
        try {
            const res = await axiosInstance.get(salesURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setSales(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setFetchWithdrawal(false);
            setFilterBtnDisabled(false);
        }
    };

    const [exportDataListLoading, setExportDataListLoading] = useState(false);
    function convertDataForSheet(data) {
        if (!data || data.length === 0) {
            warningAlert('There is no data to export');
            throw new Error('Data array is empty or undefined.');
        }

        const headers = Object.keys(data[0]);
        const dataArray = [headers];

        data.forEach((item) => {
            const row = headers.map((key) => item[key]);
            dataArray.push(row);
        });

        return XLSX.utils.aoa_to_sheet(dataArray);
    }
    const exportDataAsXlsx = async () => {
        setFilterBtnDisabled(true);
        setTimeout(() => {
            setFilterBtnDisabled(false);
        }, 3000);
        setExportDataListLoading(true);
        if (!filterSalesFrom.isValid() || !filterSalesTo.isValid()) {
            warningAlert('Please fill all required fields.');
            return;
        }
        let salesURL = `/Withdrawal/All?createdDateFrom=${filterSalesFrom.format('YYYY-MM-DD')}&createdDateTo=${filterSalesTo.format(
            'YYYY-MM-DD'
        )}`;

        if (insertWithdrawalCustomerName !== '') {
            salesURL += `&clientName=${insertWithdrawalCustomerName}`;
        }

        if (filterWithdrawalLoginUserName !== '') {
            salesURL += `&loginUserName=${filterWithdrawalLoginUserName}`;
        }

        if (filterSalesUserName !== '') {
            salesURL += `&searchUserID=${filterSalesUserName}`;
        }
        if (filterSalesStatus !== '') {
            salesURL += `&statusID=${filterSalesStatus}`;
        }
        if (filterSalesPackage !== '') {
            salesURL += `&packageID=${filterSalesPackage}`;
        }
        if (filterSalesThirdParty !== '') {
            salesURL += `&thirdPartyID=${filterSalesThirdParty}`;
        }

        if (filterSalesCustomerID !== '') {
            salesURL += `&numberCode=${filterSalesCustomerID}`;
        }

        try {
            const res = await axiosInstance.get(salesURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                const fileName = `Wtihdrawal_${dayjs().format('MM-DD-YYYY')}`;
                const workbook = XLSX.utils.book_new();
                const worksheet = convertDataForSheet(res.data);
                // Adjust column widths
                const headers = Object.keys(res.data[0]);
                const colWidths = headers.map((header) => ({ wch: header.length + 2 }));

                worksheet['!cols'] = colWidths;

                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                XLSX.writeFile(workbook, `${fileName}.xlsx`);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setExportDataListLoading(false);
        }
    };

    const [batchUpdateLoading, setBatchUpdateLoading] = useState(false);
    const batchUpdateWithdrawalPending = async () => {
        setBatchUpdateLoading(true);
        try {
            const res = await axiosInstance.post(
                '/BatchUpdate/Withdrawal/Pending',
                {
                    dateFrom: filterSalesFrom.format('YYYY-MM-DD'),
                    dateTo: filterSalesTo.format('YYYY-MM-DD')
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('Batch Update Success.');
            } else {
                errorAlert('Something went wrong');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setBatchUpdateLoading(false);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
        buttonRef.current.click(); // Simulate button click
        }
    };

    //insert sales start
    const InsertSalesRecord = () => {
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);

        const [insertWithdrawalCustomerID, setInsertWithdrawalCustomerID] = useState('');
        const [insertWithdrawalClientLoginUserName, setInsertWithdrawalClientLoginUserName] = useState('');
        const [insertWithdrawalAmount, setInsertWithdrawalAmount] = useState(0);
        const [insertWithdrawalStatusID, setInsertWithdrawalStatusID] = useState('');

        const [insertBtnDisabled, setInsertBtnDisabled] = useState(false);
        const [insertWithdrawalLoading, setInsertWithdrawalLoading] = useState(false);

        const submitInsertSales = async (e) => {
            setInsertBtnDisabled(true);
            setTimeout(() => {
                setInsertBtnDisabled(false);
            }, 3000);

            if (insertWithdrawalAmount === 0 || insertWithdrawalStatusID === 0) {
                warningAlert('Please fill all required fields.');
                return;
            }
            setInsertWithdrawalLoading(true);
            try {
                const res = await axiosInstance.post(
                    '/Withdrawal',
                    {
                        // customerID: insertWithdrawalCustomerID,
                        loginUserName: insertWithdrawalClientLoginUserName,
                        amount: parseFloat(insertWithdrawalAmount),
                        statusID: parseFloat(insertWithdrawalStatusID)
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('Sales created successfully.');
                    fetchSales();
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setInsertWithdrawalLoading(false);
            }
        };

        return (
            <>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: deepPurple[500],
                        color: 'white',
                        marginLeft: 'auto',
                        marginBottom: '20px',
                        marginRight: '20px'
                    }}
                >
                    Insert Withdrawal
                </Button>

                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {insertWithdrawalLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    Insert Withdrawal
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box
                                id="modal-modal-description"
                                sx={{
                                    height: '350px',
                                    overflowY: 'auto'
                                }}
                            >
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Login UserName :
                                            </Typography>
                                            <Autocomplete
                                                freeSolo
                                                value={insertWithdrawalClientLoginUserName}
                                                onChange={(event, newValue) => {
                                                    setInsertWithdrawalClientLoginUserName(newValue);
                                                }}
                                                inputValue={insertWithdrawalClientLoginUserName}
                                                onInputChange={(event, newInputValue) => {
                                                    setInsertWithdrawalClientLoginUserName(newInputValue);
                                                }}
                                                id="controllable-states-demo"
                                                options={customerLoginUserNameOptions}
                                                sx={{ width: 170 }}
                                                renderInput={(params) => <TextField {...params} />}
                                                disableClearable
                                            />
                                            {/* <Select
                                                displayEmpty
                                                value={insertWithdrawalCustomerID}
                                                onChange={(e) => setInsertWithdrawalCustomerID(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Customer
                                                </MenuItem>
                                                {customerNameListArr.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select> */}
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span> Amount :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={insertWithdrawalAmount}
                                                onChange={(e) => setInsertWithdrawalAmount(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span> StatusID :
                                            </Typography>

                                            <Select
                                                displayEmpty
                                                value={insertWithdrawalStatusID}
                                                onChange={(e) => setInsertWithdrawalStatusID(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Status
                                                </MenuItem>
                                                {saleStatus.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitInsertSales()}
                                disabled={insertBtnDisabled}
                            >
                                Create
                            </Button>
                        </Box>
                    )}
                </Modal>
            </>
        );
    };
    //insert sales end

    //update sales start
    const UpdateSalesRecord = ({ sale }) => {
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);
        const [updateWithdrawalAmount, setUpdateWithdrawalAmount] = useState(sale.amount);
        const [updateWithdrawalStatusID, setUpdateWithdrawalStatusID] = useState(sale.statusID);
        const [updateWithdrawalRejectReasonID, setUpdateWithdrawalRejectReasonID] = useState(sale.rejectReasonID || "");

        const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);
        const [updateWithdrawalLoading, setUpdateWithdrawalLoading] = useState(false);

        const submitUpdateSales = async () => {
            setUpdateBtnDisabled(true);
            setTimeout(() => {
                setUpdateBtnDisabled(false);
            }, 3000);
            if (parseFloat(updateWithdrawalAmount) === 0 || parseFloat(updateWithdrawalStatusID) === 0) {
                warningAlert('Please fill all required fields.');
                return;
            }
            setUpdateWithdrawalLoading(true);
            try {
                const res = await axiosInstance.put(
                    '/Withdrawal',
                    {
                        id: sale.id,
                        amount: parseFloat(updateWithdrawalAmount),
                        statusID: parseFloat(updateWithdrawalStatusID),
                        rejectReasonID: updateWithdrawalRejectReasonID ? parseFloat(updateWithdrawalRejectReasonID) : null
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('Sales updated successfully.');
                    fetchSales();
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setUpdateWithdrawalLoading(false);
            }
        };

        return (
            <>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: 'transparent',
                        width: 'fit-content',
                        height: 'fit-content',
                        color: deepPurple[500]
                    }}
                >
                    <ManageAccounts />
                </Button>

                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {updateWithdrawalLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    Update Withdrawal
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box
                                id="modal-modal-description"
                                sx={{
                                    height: '300px',
                                    overflowY: 'auto'
                                }}
                            >
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Amount :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updateWithdrawalAmount}
                                                onChange={(e) => setUpdateWithdrawalAmount(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Status
                                            </Typography>

                                            <Select
                                                displayEmpty
                                                value={updateWithdrawalStatusID}
                                                onChange={(e) => setUpdateWithdrawalStatusID(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Status
                                                </MenuItem>
                                                {saleStatus.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Reject Reason
                                            </Typography>

                                            <Select
                                                displayEmpty
                                                value={updateWithdrawalRejectReasonID}
                                                onChange={(e) => setUpdateWithdrawalRejectReasonID(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Reject Reason
                                                </MenuItem>
                                                {withdrawalRejectReasonOptions.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitUpdateSales()}
                                disabled={updateBtnDisabled}
                            >
                                Update
                            </Button>
                        </Box>
                    )}
                </Modal>
            </>
        );
    };
    //update sales end

    //Change Adjustment start
    // const ChangeUser = ({ withdrawalId }) => {
    //     const [open, setOpen] = useState(false);
    //     const handleOpen = () => setOpen(true);
    //     const handleClose = () => setOpen(false);

    //     const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);
    //     const [updateSalesRecordLoading, setUpateSalesRecordLoading] = useState(false);

    //     const [oldUsername, setOldUsername] = useState('');
    //     const [newUsername, setNewUsername] = useState('');

    //     const submitUpdateSales = async () => {
    //         setUpdateBtnDisabled(true);
    //         setTimeout(() => {
    //             setUpdateBtnDisabled(false);
    //         }, 3000);
    //         if (parseFloat(withdrawalId) === 0 || oldUsername === '' || newUsername === '') {
    //             warningAlert('Please fill all required fields.');
    //             return;
    //         }
    //         setUpateSalesRecordLoading(true);
    //         try {
    //             const res = await axiosInstance.put(
    //                 '/Withdrawal/ChangeUser',
    //                 {
    //                     withdrawalID: withdrawalId,
    //                     oldUserName: oldUsername,
    //                     newUserName: newUsername
    //                 },
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${token}`
    //                     }
    //                 }
    //             );
    //             if (res.status === 200) {
    //                 successAlert('Your username has been updated.');
    //                 fetchAdjustment();
    //             } else {
    //                 errorAlert('Something went wrong.');
    //             }
    //         } catch (error) {
    //             console.log(error);
    //         } finally {
    //             setUpateSalesRecordLoading(false);
    //         }
    //     };

    //     return (
    //         <>
    //             <Button
    //                 onClick={handleOpen}
    //                 sx={{
    //                     border: 'none',
    //                     backgroundColor: 'transparent',
    //                     width: 'fit-content',
    //                     height: 'fit-content',
    //                     color: deepPurple[500]
    //                 }}
    //             >
    //                 <ChangeCircleIcon />
    //             </Button>

    //             <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
    //                 {updateSalesRecordLoading ? (
    //                     <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
    //                         <CircularProgress />
    //                     </Box>
    //                 ) : (
    //                     <Box sx={style}>
    //                         <Box
    //                             sx={{
    //                                 display: 'flex',
    //                                 alignItems: 'center',
    //                                 justifyContent: 'space-between'
    //                             }}
    //                         >
    //                             <Typography id="modal-modal-title" variant="h3" component="h2">
    //                                 Change Username
    //                             </Typography>
    //                             <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
    //                         </Box>
    //                         <Box
    //                             id="modal-modal-description"
    //                             sx={{
    //                                 height: '300px',
    //                                 overflowY: 'auto'
    //                             }}
    //                         >
    //                             <Grid item container xs={12} sx={{ mt: 2 }}>
    //                                 <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
    //                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
    //                                         <Typography
    //                                             sx={{
    //                                                 fontSize: '16px',
    //                                                 whiteSpace: 'nowrap'
    //                                             }}
    //                                         >
    //                                             <span style={{ color: 'red' }}>*</span>Old Username :
    //                                         </Typography>
    //                                         <FormControl fullWidth>
    //                                             <Select value={oldUsername} onChange={(e) => setOldUsername(e.target.value)}>
    //                                                 <MenuItem sx={{ width: '100%' }} value="">
    //                                                     Old Username
    //                                                 </MenuItem>
    //                                                 {usersList.map((item, index) => (
    //                                                     <MenuItem sx={{ width: '100%' }} value={item.userName} key={index}>
    //                                                         {item.userName}
    //                                                     </MenuItem>
    //                                                 ))}
    //                                             </Select>
    //                                         </FormControl>
    //                                     </Box>
    //                                 </Grid>

    //                                 <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
    //                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
    //                                         <Typography
    //                                             sx={{
    //                                                 fontSize: '16px',
    //                                                 whiteSpace: 'nowrap'
    //                                             }}
    //                                         >
    //                                             <span style={{ color: 'red' }}>*</span>New Username :
    //                                         </Typography>
    //                                         <FormControl fullWidth>
    //                                             <Select value={newUsername} onChange={(e) => setNewUsername(e.target.value)}>
    //                                                 <MenuItem sx={{ width: '100%' }} value="">
    //                                                     New Username
    //                                                 </MenuItem>
    //                                                 {usersList.map((item, index) => (
    //                                                     <MenuItem sx={{ width: '100%' }} value={item.userName} key={index}>
    //                                                         {item.userName}
    //                                                     </MenuItem>
    //                                                 ))}
    //                                             </Select>
    //                                         </FormControl>
    //                                     </Box>
    //                                 </Grid>
    //                             </Grid>
    //                         </Box>
    //                         <Button
    //                             variant="contained"
    //                             sx={{
    //                                 display: 'block',
    //                                 mx: 'auto',
    //                                 width: '150px',
    //                                 backgroundColor: deepPurple[500],
    //                                 marginTop: '50px'
    //                             }}
    //                             onClick={() => submitUpdateSales()}
    //                             disabled={updateBtnDisabled}
    //                         >
    //                             Update
    //                         </Button>
    //                     </Box>
    //                 )}
    //             </Modal>
    //         </>
    //     );
    // };
    //Change Adjustment end

    useEffect(() => {
        setLoading(false);

        Promise.all([
            // fetchIsAllowedTransaction(),
            // fetchExpensesTypes(),
            // fetchPackages(),
            fetchSales(),
            // fetchThirdParty(),
            fetchSalesStatus(),
            fetchCustomerNamesOptions(),
            // fetchCustomerNamesList(),
            // fetchCurrency(),
            // fetchUserNamesOptions(),
            // fetchIsUserAllowEdit()
        ]).catch((error) => {
            // Handle errors if any of the promises fail
            console.error('An error occurred:', error);
        });
    }, []);

    //sales table start
    function StickyHeadTable() {
        const [page, setPage] = useState(0);
        const [rowsPerPage, setRowsPerPage] = useState(100);
        const [selectedCustomerRow, setSelectedCustomerRow] = useState(null);
        const [approveWithdrawalModalOpen, setApproveWithdrawalModalOpen] = useState(false);
        const [rejectWithdrawalModalOpen, setRejectWithdrawalModalOpen] = useState(false);
        const [updateUnderReviewWithdrawalModalOpen, setUpdateUnderReviewWithdrawalModalOpen] = useState(false);

        const handleChangePage = (event, newPage) => {
            setPage(newPage);
        };

        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(+event.target.value);
            setPage(0);
        };
    
        const openApproveWithdrawalModal = (row) => {
            setSelectedCustomerRow(row);
            setApproveWithdrawalModalOpen(true);
        };
    
        const openRejectWithdrawalModal = (row) => {
            setSelectedCustomerRow(row);
            setRejectWithdrawalModalOpen(true);
        };
    
        const openUnderReviewWithdrawalModal = (row) => {
            setSelectedCustomerRow(row);
            setUpdateUnderReviewWithdrawalModalOpen(true);
        };

        return (
            <>
                <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '30px' }}>
                    <TableContainer sx={{ height: '100vh' }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell key="id" style={{ minWidth: 170 }}>{t("withdrawal.date")}</TableCell>
                                    <TableCell key="customerDetails" style={{ minWidth: 170 }}>{t("withdrawal.customer")}</TableCell>
                                    <TableCell key="createdBy" style={{ minWidth: 170 }}>{t("withdrawal.admin")}</TableCell>
                                    <TableCell key="bankDetails" style={{ minWidth: 170 }}>{t("withdrawal.bankDetails")}</TableCell>
                                    <TableCell key="amount" style={{ minWidth: 170 }}>{t("withdrawal.actualAmount")}</TableCell>
                                    <TableCell key="updatedBy" style={{ minWidth: 170 }}>{t("withdrawal.updatedBy")}</TableCell>
                                    <TableCell key="action" style={{ minWidth: 170 }}>{t("withdrawal.setting")}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {sales.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                    return (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                            <TableCell key='id' style={{fontSize: "12px"}}>
                                                ID : {row.id} <br/>
                                                {t("withdrawal.createdAt")} {
                                                `${row.createdDate.split('T')[0]} ${new Date(
                                                    '1970-01-01T' + row.createdDate.split('T')[1] + 'Z'
                                                ).toLocaleTimeString('en-US', {
                                                    timeZone: 'UTC',
                                                    hour12: true,
                                                    hour: 'numeric',
                                                    minute: 'numeric',
                                                    second: 'numeric'
                                                })}`}
                                            </TableCell>
                                            <TableCell key='customerDetails' style={{fontSize: "12px"}}>
                                                {t("withdrawal.code")} : {row.numberCode} <br/>
                                                {row.loginUserName} ( {row.clientName} ) <br/>
                                                {t("withdrawal.walletBalance")} : {row.assetBalance} <br/>
                                                {t("withdrawal.phoneNumber")} : {row.phoneNumber} <br/>
                                            </TableCell>
                                            <TableCell key='createdBy' style={{fontSize: "12px"}}>
                                                {t("withdrawal.admin")}: {row.createdBy} <br/>
                                                {t("withdrawal.by")}: {row.referrerCustomerLoginUserName} {t("withdrawal.recommend")}
                                            </TableCell>
                                            <TableCell key='bankDetails' style={{fontSize: "12px"}}>
                                                {t("withdrawal.withdrawalAmount")} : {row.amount} <br/>
                                                {t("withdrawal.network")} : {row.thirdPartyName} <br/>
                                                {t("withdrawal.walletAddress")} : {row.bankAccountNumber}<br/>
                                                {
                                                    row.isDuplicateBank &&
                                                    <>
                                                        <span style={{color: 'red'}}>
                                                            {t("withdrawal.duplicateWalletAddress")}
                                                        </span>
                                                    </>
                                                }
                                            </TableCell>
                                            <TableCell key='amount' style={{fontSize: "12px"}}>
                                                {row.amount} <br/>
                                                <span style={{ fontWeight: 'bolder', color: row.statusID === 1 ? 'orange' : row.statusID === 2 ? 'green' : row.statusID === 3 ? 'red' : row.statusID === 4 ? 'blue' : '' }}>
                                                    {row.statusID === 1 ? t("withdrawal.pending") : row.statusID === 2 ? t("withdrawal.approved") : row.statusID === 3 ? t("withdrawal.rejected") : row.statusID === 4 ? t("withdrawal.underReview") : ''}
                                                </span><br/>
                                                {row.remark && <>{t("withdrawal.rejectionReason")} : {row.remark}</>}
                                            </TableCell>
                                            <TableCell key='updatedBy' style={{fontSize: "12px"}}>
                                                {row.updatedBy}
                                            </TableCell>
                                            <TableCell key='action' style={{fontSize: "12px"}}>
                                                <Button
                                                    onClick={() => openApproveWithdrawalModal(row)}
                                                    variant="contained"
                                                    style={{
                                                        border: 'none',
                                                        backgroundColor: 'green',
                                                        width: 'fit-content',
                                                        height: 'fit-content',
                                                        color: 'white',
                                                        padding: '6px 8px',
                                                        fontSize: '12px'
                                                    }}
                                                >
                                                    {t("withdrawal.approve")}
                                                </Button>
                                                <br/><br/>
                                                <Button
                                                    onClick={() => openRejectWithdrawalModal(row)}
                                                    variant="contained"
                                                    style={{
                                                        border: 'none',
                                                        backgroundColor: 'red',
                                                        width: 'fit-content',
                                                        height: 'fit-content',
                                                        color: 'white',
                                                        padding: '6px 8px',
                                                        fontSize: '12px'
                                                    }}
                                                >
                                                    {t("withdrawal.reject")}
                                                </Button>
                                                <br/><br/>
                                                <Button
                                                    onClick={() => openUnderReviewWithdrawalModal(row)}
                                                    variant="contained"
                                                    style={{
                                                        border: 'none',
                                                        backgroundColor: 'blue',
                                                        width: 'fit-content',
                                                        height: 'fit-content',
                                                        color: 'white',
                                                        padding: '6px 8px',
                                                        fontSize: '12px'
                                                    }}
                                                >
                                                    {t("withdrawal.underReview")}
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={sales.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
            
                {selectedCustomerRow && (
                    <ApproveWithdrawalModal
                        approveWithdrawalModalOpen={approveWithdrawalModalOpen}
                        setApproveWithdrawalModalOpen={setApproveWithdrawalModalOpen}
                        withdrawalRow={selectedCustomerRow}
                        fetchWithdrawal={fetchSales}
                    />
                )}
            
                {selectedCustomerRow && (
                    <RejectWithdrawalModal
                        rejectWithdrawalModalOpen={rejectWithdrawalModalOpen}
                        setRejectWithdrawalModalOpen={setRejectWithdrawalModalOpen}
                        withdrawalRow={selectedCustomerRow}
                        fetchWithdrawal={fetchSales}
                    />
                )}
            
                {selectedCustomerRow && (
                    <UpdateUnderReviewWithdrawalModal
                        updateUnderReviewWithdrawalModalOpen={updateUnderReviewWithdrawalModalOpen}
                        setUpdateUnderReviewWithdrawalModalOpen={setUpdateUnderReviewWithdrawalModalOpen}
                        withdrawalRow={selectedCustomerRow}
                        fetchWithdrawal={fetchSales}
                    />
                )}
            </>
        );
    }
    //sales table end
    
    const [isUserAllowEdit, setIsUserAllowEdit] = useState(false);
    const fetchIsUserAllowEdit = async () => {
        try {
            const res = await axiosInstance.get('IsAllowEdit', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setIsUserAllowEdit(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Grid container item xs={12} onKeyDown={handleKeyDown} tabIndex={0}>
            {isUserAllowEdit &&
                <Box item xs={12} sx={{ display: 'flex', justifyContent: 'end', gap: '10px', width: '100%', alignItems: 'center' }}>
                    {/* <Box>
                        <BatchUpdateWithdrawalModal />
                    </Box> */}
                    {/* <Button
                        variant="contained"
                        sx={{
                            display: 'block',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '20px'
                        }}
                        onClick={batchUpdateWithdrawalPending}
                        disabled={batchUpdateLoading}
                    >
                        Batch Update
                    </Button> */}
                    {/* <Box>
                        <InsertSalesRecord />
                    </Box> */}
                </Box>
            }

            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={6}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>{t("withdrawal.createdDate")} :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterSalesFrom}
                                slotProps={{
                                    textField: {
                                        error: false,
                                        size: 'small', // makes the input smaller (MUI supports 'small' and 'medium')
                                        sx: {
                                          '& .MuiInputBase-root': {
                                            fontSize: '13px',      // font size of the input
                                            padding: '4px 8px',    // optional: reduce input padding
                                            minHeight: '36px',     // optional: control input height
                                          },
                                          '& .MuiInputBase-input': {
                                            fontSize: '13px',      // font size inside input
                                            padding: '8.5px 14px', // adjust input padding if needed
                                          },
                                          '& .MuiInputLabel-root': {
                                            fontSize: '13px',      // label font size
                                          },
                                        },
                                    }
                                }}
                                onChange={(newValue) => setFilerSalesFrom(newValue)}
                            />
                        </LocalizationProvider>
                        -
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterSalesTo}
                                slotProps={{
                                    textField: {
                                        error: false,
                                        size: 'small', // makes the input smaller (MUI supports 'small' and 'medium')
                                        sx: {
                                          '& .MuiInputBase-root': {
                                            fontSize: '13px',      // font size of the input
                                            padding: '4px 8px',    // optional: reduce input padding
                                            minHeight: '36px',     // optional: control input height
                                          },
                                          '& .MuiInputBase-input': {
                                            fontSize: '13px',      // font size inside input
                                            padding: '8.5px 14px', // adjust input padding if needed
                                          },
                                          '& .MuiInputLabel-root': {
                                            fontSize: '13px',      // label font size
                                          },
                                        },
                                    }
                                }}
                                onChange={(newValue) => setFilerSalesTo(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>

                {/* <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>To :
                        </Typography>
                    </Box>
                </Grid> */}

                {/* Client Name */}
                {/* <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Client Name :
                        </Typography>

                        <Select
                            displayEmpty
                            value={insertWithdrawalCustomerName}
                            onChange={(e) => setInsertWithdrawalCustomerName(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                Select Customer
                            </MenuItem>
                            {customerNameListArr.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.name} key={index}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid> */}
                <Grid item container xs={12} md={6} lg={3}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {t("withdrawal.loginUserName")} :
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            value={filterWithdrawalLoginUserName}
                            onChange={(e) => setFilterWithdrawalLoginUserName(e.target.value)}
                            sx={{
                                fontSize: '13px',
                                minHeight: '24px',
                                '& .MuiInputBase-root': {
                                    fontSize: '13px',
                                    minHeight: '24px',
                                    padding: '4px 6px',
                                },
                                '& input': {
                                    padding: '4px 6px',
                                },
                            }}
                        />
                        {/* <Autocomplete
                            freeSolo
                            options={customerLoginUserNameOptions}
                            value={filterWithdrawalLoginUserName}
                            inputValue={filterWithdrawalLoginUserNameInputText}
                            onInputChange={(event, newInputValue, reason) => {
                                if (reason === 'clear' || newInputValue === '') {
                                    // User cleared the input
                                    setFilterWithdrawalLoginUserNameInputText('');
                                    setFilterWithdrawalLoginUserName('');
                                    setFilterWithdrawalLoginUserNameHighlightedOption(null);
                                } else {
                                    setFilterWithdrawalLoginUserNameInputText(newInputValue);
                                }
                            }}
                            onHighlightChange={(event, option) => {
                                setFilterWithdrawalLoginUserNameHighlightedOption(option);
                            }}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    setFilterWithdrawalLoginUserName(newValue);
                                    setFilterWithdrawalLoginUserNameInputText(newValue);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();

                                    // 🟡 Set flag so button click doesn't double-fire
                                    triggeredByKeyRef.current = true;

                                    // Trigger the button click manually
                                    if (buttonRef.current) {
                                        buttonRef.current.click();
                                    }
                                }
                            }}
                            sx={{ width: 170 }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    size="small"
                                    sx={{
                                        '& .MuiInputBase-root': {
                                        fontSize: '13px',
                                        minHeight: '36px',
                                        padding: '10px 14px',
                                        },
                                        '& .MuiAutocomplete-input': {
                                        fontSize: '13px',
                                        padding: '10px 14px',
                                        },
                                        '& .MuiInputLabel-root': {
                                        fontSize: '13px',
                                        },
                                    }}
                                />
                            )}
                            isOptionEqualToValue={(option, value) => option === value}
                            disableClearable
                        /> */}
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={3}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {t("withdrawal.code")} :
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            value={filterWithdrawalNumberCode}
                            onChange={(e) => setFilterWithdrawalNumberCode(e.target.value)}
                            sx={{
                                fontSize: '13px',
                                minHeight: '24px',
                                '& .MuiInputBase-root': {
                                    fontSize: '13px',
                                    minHeight: '24px',
                                    padding: '4px 6px',
                                },
                                '& input': {
                                    padding: '4px 6px',
                                },
                            }}
                        />
                        {/* <Autocomplete
                            freeSolo
                            options={customerNumberCodeOptions}
                            value={filterWithdrawalNumberCode}
                            inputValue={filterWithdrawalNumberCodeInputText}
                            onInputChange={(event, newInputValue, reason) => {
                                if (reason === 'clear' || newInputValue === '') {
                                    // User cleared the input
                                    setFilterWithdrawalNumberCodeInputText('');
                                    setFilterWithdrawalNumberCode('');
                                    setFilterWithdrawalNumberCodeHighlightedOption(null);
                                } else {
                                    setFilterWithdrawalNumberCodeInputText(newInputValue);
                                }
                            }}
                            onHighlightChange={(event, option) => {
                                setFilterWithdrawalNumberCodeHighlightedOption(option);
                            }}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    setFilterWithdrawalNumberCode(newValue);
                                    setFilterWithdrawalNumberCodeInputText(newValue);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();

                                    // 🟡 Set flag so button click doesn't double-fire
                                    triggeredByKeyRef.current = true;

                                    // Trigger the button click manually
                                    if (buttonRef.current) {
                                        buttonRef.current.click();
                                    }
                                }
                            }}
                            sx={{ width: 170 }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    size="small"
                                    sx={{
                                        '& .MuiInputBase-root': {
                                        fontSize: '13px',
                                        minHeight: '36px',
                                        padding: '10px 14px',
                                        },
                                        '& .MuiAutocomplete-input': {
                                        fontSize: '13px',
                                        padding: '10px 14px',
                                        },
                                        '& .MuiInputLabel-root': {
                                        fontSize: '13px',
                                        },
                                    }}
                                />
                            )}
                            isOptionEqualToValue={(option, value) => option === value}
                            disableClearable
                        /> */}
                    </Box>
                </Grid>

                {/* filterSalesStatus */}
                <Grid item container xs={12} md={6} lg={3}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {t("withdrawal.withdrawalStatus")} :
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterSalesStatus}
                            onChange={(e) => setFilterSalesStatus(e.target.value)}
                            sx={{
                                fontSize: '13px',
                                minHeight: '36px',
                                '& .MuiSelect-select': {
                                    fontSize: '13px',
                                    padding: '10px 14px',
                                },
                                '& .MuiInputBase-root': {
                                    fontSize: '13px',
                                    minHeight: '36px',
                                    padding: '10px 14px',
                                },
                            }}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                {t("withdrawal.pleaseSelectWithdrawalStatus")}
                            </MenuItem>
                            {saleStatus.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                    {item.id === 1 ? t("withdrawal.pending") : item.id === 2 ? t("withdrawal.approved") : item.id === 3 ? t("withdrawal.rejected") : item.id === 4 ? t("withdrawal.underReview") : ''}
                                    {/* {item.name} */}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={3}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {t("withdrawal.walletAddress")} :
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            value={filterSalesBankAccountNumber}
                            onChange={(e) => setFilterSalesBankAccountNumber(e.target.value)}
                            sx={{
                                fontSize: '13px',
                                minHeight: '24px',
                                '& .MuiInputBase-root': {
                                    fontSize: '13px',
                                    minHeight: '24px',
                                    padding: '4px 6px',
                                },
                                '& input': {
                                    padding: '4px 6px',
                                },
                            }}
                        />
                    </Box>
                </Grid>

                {/* <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Customer ID :
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            value={filterSalesCustomerID}
                            onChange={(e) => setFilterSalesCustomerID(e.target.value)}
                        />
                    </Box>
                </Grid> */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'end',
                        alignItems: 'center',
                        gap: '15px',
                        width: '50%',
                        marginLeft: 'auto'
                    }}
                >
                    <Button
                        variant="contained"
                        sx={{
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '20px'
                        }}
                        onClick={() => fetchSales()}
                        disabled={filterBtnDisabled}
                        ref={buttonRef}
                    >
                        {t("withdrawal.filter")}
                    </Button>
                    
                    {/* <Button
                        variant="contained"
                        sx={{
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '20px'
                        }}
                        onClick={() => exportDataAsXlsx()}
                        disabled={filterBtnDisabled}
                    >
                        Export Data
                    </Button> */}
                </Box>
            </Grid>
            <Box sx={{ width: '100%', minHeight: '200px' }}>
                {fetchWithdrawal ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <StickyHeadTable />
                )}
            </Box>
        </Grid>
    );
};

export default SalesRecord;
